'use client'

import React from 'react'
import dataUriToBuffer from 'data-uri-to-buffer'

import generateQRCodeDataURL from './generateQRCodeDataURL'
import TextToImageTransformerLayout from '../../../../components/layouts/TextToImageTransformerLayout'


export default function QRCodeGenerator() {
  const convertFunc = React.useCallback((input) => generateQRCodeDataURL(input)
      .then(output => [output, dataUriToBuffer(output)])
    , [])

  return (
    <TextToImageTransformerLayout
      transform={convertFunc}
    />
  )
}

